import { makeUniqueId } from "./makeUniqueId.js";
export function stringifyForDisplay(value) {
    var undefId = makeUniqueId("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/common/stringifyForDisplay.js
// module id = 1528
// module chunks = 4